import React, { FC, useEffect, useState } from 'react'
import clsx from 'clsx'

import { sortByTotalPoints } from '../../../../data/operations-tab-utils'

import FirestoreService from '../../../../../../../../../services/firestoreService'
import { IRegistrationByDayEx } from '../../../../ManageClinicNOtherOperationsTab'

import { IRegistrationByDayInterface } from '../../../../../../../../../models/registrations-by-day/registrationByDay.interface'
import { RegistrationByDayModel } from '../../../../../../../../../models/registrations-by-day/registrationByDay.model'

import { CONST } from '../../../../../../../../../const/const'
const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

interface TotalPointsInputProps {
  row: IRegistrationByDayEx
  setRegistrationsByDay: (value: IRegistrationByDayInterface[]) => void
  registrationsByDay: IRegistrationByDayInterface[] | null
}

export const TotalPointsInput: FC<TotalPointsInputProps> = ({
  row,
  setRegistrationsByDay,
  registrationsByDay,
}) => {
  const [totalPoints, setTotalPoints] = useState('')

  const onBlurTotalPoints = async (event: any, row: IRegistrationByDayInterface) => {
    const value = event.target.value
    const valueWithoutLeadingZeros = value === '0' ? value : value.replace(/^0+/, '')
    setTotalPoints(valueWithoutLeadingZeros)

    let current: IRegistrationByDayInterface

    // get the current registration by day
    let registrationsByDayUpdated: IRegistrationByDayInterface[] =
      registrationsByDay?.map((registrationByDay) => {
        if (registrationByDay.id === row.id) {
          const updated = {
            ...registrationByDay,
            score: {
              ...registrationByDay.score,
              totalPoints: valueWithoutLeadingZeros,
              sheet: registrationByDay.score?.sheet ?? null,
              judges: registrationByDay.score?.judges ?? [],
            },
          }
          current = updated
          return updated
        } else {
          return registrationByDay
        }
      }) ?? []

    // sort registrations by total points
    let sortedRegistrations = sortByTotalPoints(registrationsByDayUpdated)

    let count = 0

    // update rank for all registrations that have the same class
    sortedRegistrations = sortedRegistrations?.map((registrationByDay) => {
      if (current.uuid === registrationByDay.uuid) {
        count++
        return {
          ...registrationByDay,
          ...(registrationByDay.score && {
            score: { ...registrationByDay.score, rank: count },
          }),
        }
      } else {
        return registrationByDay
      }
    })

    setRegistrationsByDay([...sortedRegistrations])

    // Update firestore collection
    if (sortedRegistrations?.length) {
      await Promise.all(
        sortedRegistrations.map(async (registrationByDay) => {
          const item = new RegistrationByDayModel(registrationByDay)
          await FirestoreService.updateItem(
            COLLECTIONS.REGISTRATION_BY_DAY.NAME,
            item.id,
            item.toFirestore()
          )
        })
      )
    }
  }

  useEffect(() => {
    setTotalPoints(String(row.score?.totalPoints) ?? '')
  }, [row.score?.totalPoints])

  return (
    <input
      style={{ boxShadow: 'none', outline: 'none' }}
      type="number"
      className={clsx(
        'border-0 outline-0 text-SeabiscuitDark200ThemeColor text-base text-right underline hover:no-underline focus:no-underline cursor-pointer'
      )}
      placeholder="Enter number"
      value={Number(totalPoints) ? totalPoints : ''}
      onChange={(event) => setTotalPoints(event.target.value)}
      onBlur={(event) => onBlurTotalPoints(event, row)}
    />
  )
}
